import { Component, OnInit, ViewChild } from '@angular/core';
import { Page } from '../shared/page';
import { HistoryService } from './history.service';
import { MatPaginator, MatSort, MatSortable, MatTableDataSource } from '@angular/material';
import { MatchingHistory } from '../shared/matching-history';
import { DatePipe } from '@angular/common';
import { IsrcPipe } from '../pipes/isrc.pipe';

import { HistoryUndoButtonRendererComponent } from './history-undo-cell.component';

@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.css']
})
export class HistoryComponent implements OnInit {

  page: Page = {
    title: 'Match History',
    subtitle: ' - shows the history of the last 7 days matches made through this system'
  };

  public gridError = false;
  public itemsPerPage = 25;
  public columnDefs;
  public getRowHeight;
  public frameworkComponents = {
    operationButtonRenderer: HistoryUndoButtonRendererComponent
  };

  private gridApi;

  constructor(private historyService: HistoryService, private datePipe: DatePipe, private isrcPipe: IsrcPipe) { }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.gridApi.setQuickFilter(filterValue);

    this.gridOverlay(this.gridApi.getDisplayedRowCount());
  }

  ngOnInit() {
    this.columnDefs = [
      {
        headerName: '',
        field: 'value',
        cellRenderer: 'operationButtonRenderer',
        colId: 'params',
        width: 110,
        sortingOrder: [null],
        pinned: 'left',
        suppressSizeToFit: true,
        suppressResize: true,
        lockPosition: true
      },
      {
        headerName: 'Date',
        field: 'dateModified',
        width: 120,
        sort: 'desc',
        cellRenderer: (params) => {
          return this.datePipe.transform(params.value, 'yyyy-MM-dd hh:mm:ss');
        },
        lockPosition: true
      },
      {
        headerName: 'CCID',
        field: 'ccid',
        width: 75,
        lockPosition: true
      },
      {
        headerName: 'Title',
        field: 'trackTitle',
        width: 200,
        lockPosition: true
      },
      {
        headerName: 'Artist',
        field: 'artist',
        width: 200,
        lockPosition: true
      },
      {
        headerName: 'Album',
        field: 'album',
        width: 200,
        lockPosition: true
      },
      {
        headerName: 'ISRC',
        field: 'isrc',
        width: 200,
        cellRenderer: (params) => {
          return this.isrcPipe.transform(params.value);
        },
        lockPosition: true
      }
    ];

    this.getRowHeight = function (params) {
      return 55;
    };
  }

  onGridReady(params) {
    this.gridError = false;
    this.gridApi = params.api;

    this.historyService.getMatchHistoryCcidList().subscribe(
      ccidListResult => {
        const matchingHistory = this.historyService.getMatchingHistory(ccidListResult);
        if (matchingHistory != null) {
          matchingHistory.subscribe(
            matchingHistoryResult => {
              this.initMatTableFromResult(matchingHistoryResult);
            },
            error => {
              this.showGridError();
            }
          );
        } else {
          this.initMatTableFromResult([]);
        }
      },
      error => {
        this.showGridError();
      });
  }

  private showGridError() {
    this.gridApi.setRowData([]);
    this.gridApi.hideOverlay();
    this.gridError = true;
  }

  gridOverlay(rowCount: number) {
    if (rowCount === 0) {
      this.gridApi.showNoRowsOverlay();
    } else {
      this.gridApi.hideOverlay();
    }
  }

  undoMatch(history: MatchingHistory) {
    this.gridApi.showLoadingOverlay();
    this.historyService.getOriginalMetaData(history.ccid).subscribe(historyRes => {
      this.historyService.undoMatchRadioFuse(historyRes).subscribe(status1 => {
        if (status1) {
          this.historyService.undoDataStewardMatch(history.ccid).subscribe(success2 => {
            if (success2) {
              this.historyService.getMatchHistoryCcidList().subscribe(ccidListResult => {
                const matchingHistory = this.historyService.getMatchingHistory(ccidListResult);
                if (matchingHistory == null) {
                  this.initMatTableFromResult([]);
                } else {
                  matchingHistory.subscribe(matchingHistoryResult => {
                    this.initMatTableFromResult(matchingHistoryResult);
                  });
                }
              });
            }
          });
        }
      });
    });
  }

  initMatTableFromResult(history: Array<MatchingHistory>) {
    if (history != null) {
      this.gridApi.setRowData(history);
      this.gridOverlay(history.length);
      this.gridApi.paginationGoToPage(0);
      this.gridApi.sizeColumnsToFit();
    }
  }

  changeItemsPerPage() {
    this.gridApi.paginationSetPageSize(this.itemsPerPage);
  }
}



// WEBPACK FOOTER //
// ./src/app/history/history.component.ts